import { z } from 'zod';

import { DelinquentInterestSettingId } from '../BrandedIds';
import { zodJSInstantDate, zodJSPlainDate } from '../dates/BrandedDate';
import { zodBrandedUuid } from '../utils';
import { InvestorRemittanceSplit } from './InvestorRemittanceSplit';

export const DelinquentInterestSetting = z.object({
  id: zodBrandedUuid<DelinquentInterestSettingId>(),
  startDate: zodJSPlainDate,
  endDate: zodJSPlainDate.optional(),
  interestRate: z.number(),
  isDeferred: z.boolean(),
  isWaived: z.boolean(),
  investorRemittanceSplit: InvestorRemittanceSplit.optional(),
  createdAt: zodJSInstantDate,
  updatedAt: zodJSInstantDate,
});

export type DelinquentInterestSetting = z.infer<typeof DelinquentInterestSetting>;

export const DelinquentInterestSettingInput = DelinquentInterestSetting.omit({
  createdAt: true,
  updatedAt: true,
})
  .partial()
  .extend({
    endDate: z.date().nullable().optional(),
  });

export type DelinquentInterestSettingInput = z.infer<typeof DelinquentInterestSettingInput>;
